import poReturn from "./po-return";
import supplierReturn from "./supplier-return";

export default {
    namespaced: true,
    modules: {
        poReturn,
        supplierReturn
    }
}